<page-layout
  [contentClass]="'px-0 pb-0'"
  [hasTopOffset]="false">
  <ng-container content>
    <mbs-loader *ngIf="showLoader"></mbs-loader>
    <iframe
      #iframe
      class="border-0 w-100 flex-grow-1"
      sandbox="allow-downloads allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
      [class.d-none]="showLoader"
      [src]="marketingSrc | safe: 'resourceUrl'"></iframe>
  </ng-container>
</page-layout>
